import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPitchbook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2151_132540)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.99974 19.6206C4.68629 19.6206 0.378906 15.3132 0.378906 9.99974C0.378906 4.68629 4.68629 0.378906 9.99974 0.378906C15.3132 0.378906 19.6206 4.68629 19.6206 9.99974C19.6206 15.3132 15.3132 19.6206 9.99974 19.6206Z",
				stroke: "#565CDE",
				strokeWidth: .758342,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.1337 4C6.01886 4.57078 3.07207 10.3051 4.25344 13.9156C4.94368 12.8802 6.21797 11.7652 8.83292 11.3537C8.67364 8.31401 9.81519 6.17691 13.1337 4Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.49813 11.7926C7.70616 12.0846 6.44515 12.5624 5.66199 13.2792C5.68854 14.235 5.95401 15.1641 6.48497 16.0004C7.09556 14.5535 9.08664 13.5314 12.1264 13.5182C11.383 10.0537 13.029 6.88123 15.6041 4.74414C14.2236 4.95652 12.9892 5.28837 11.9007 5.71313C9.93617 7.54493 9.20611 9.90767 9.49813 11.7926Z",
				fill: "#565CDE"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2151_132540",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgPitchbook;
